import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import helpTopicService from "../services/help-topic-service";

export const helpTopicSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	help_category_id: z.string().nullable().optional(),
	slug: z.string().nullable().optional(),
});

export const helpTopicsQueryOptions = (search?: z.infer<typeof helpTopicSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["help_topic", search],
		queryFn: () => helpTopicService.list(transformSearch(search, ["search", "help_category_id", "slug"])),
		...options,
	});
};

export const helpTopicQueryOptions = (id: string) => {
	return queryOptions({
		queryKey: ["help_topic", id],
		queryFn: () => helpTopicService.findById(id),
	});
};

export const useHelpTopicCreateMutation = (id?: string) => {
	return useMutation({
		mutationKey: ["help_topic", id],
		mutationFn: helpTopicService.create,
		meta: {
			successMessage: "Help Topic created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["help_topic"] }),
	});
};

export const useHelpTopicMutation = (id?: string) => {
	return useMutation({
		mutationKey: ["help_topic", id],
		mutationFn: helpTopicService.upsert,
		meta: {
			successMessage: "Help Topic updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["help_topic"] }),
	});
};
